import SumoLogger from 'sumo-logger';
import { updateError } from '../../store';
/* istanbul ignore file */

const sumoOptions = {
  endpoint: `${process.env.REACT_APP_SUMO_ENDPOINT}`,
  clientUrl: `${process.env.REACT_APP_BASE_PATH}`,
  sendErrors: true,
};

const sumoLogger = new SumoLogger(sumoOptions);

export const sendSumoLog = (
  errorType,
  message,
  errorCode,
  dispatch,
  shouldUpdateError = true
) => {
  var sumoPromise = new Promise((resolve) => {
    resolve({ errorType, message, errorCode, dispatch });
    sumoLogger.log(message, {
      error: errorType,
      code: errorCode,
      url: window.location,
    });
  });
  sumoPromise
    .then(() => {
      shouldUpdateError &&
        updateError({ errorType, message, errorCode }, dispatch);
      return errorType;
    })
    .catch((error) => {
      return error;
    });
};
